// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import arTranslation from './json/ar.json';
import enTranslation from './json/en.json';
import frTranslation from './json/fr.json';

const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('lang');
  if (!savedLanguage) {
    localStorage.setItem('lang', 'en');
    return 'en';
  }
  return savedLanguage;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
      ar: {
        translation: arTranslation,
      },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
